import React, { useState, useEffect } from 'react';
import './Setting.css';
import { assets } from '../../../assets/assets';
import Navbar from '../Navbar/Navbar';
import { Bars } from 'react-loader-spinner';

function Setting() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
     setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

     return () => clearTimeout(timer);
  }, []);  

  const handleSignIn = (event) => {
    event.preventDefault();
  };

  return (
    <>
      {isLoading ? (
         <div className="loader-container">
          <Bars
            height="80"
            width="80"
            radius="9"
            color="#333333"
            ariaLabel="loading-indicator"
          />
        </div>
      ) : (
         <>
          <Navbar />
          <div className="containers">
            <div className="signin-container">
              <h2>Setting</h2>
              <div className="signin-form">
                <div className="signin-form1">
                  <h2>Change Your Password</h2>
                  <form onSubmit={handleSignIn}>
                    <div className="input-field">
                      <div className="input-wrapper">
                        <i className="fas fa-envelope"></i>
                        <input
                          type="password"
                          id="password"
                          placeholder="Enter Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="input-field">
                      <div className="input-wrapper">
                        <i className="fas fa-envelope"></i>
                        <input
                          type="password"
                          id="confirmPassword"
                          placeholder="Enter Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <button type="submit">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Setting;
